export const envMap = {
  dev: "https://dev-receiver-metis.infeng.site/encode/web",
  test: "https://test-receiver-metis.infeng.site/encode/web",
  pre: "https://pre-receiver-metis.infeng.site/encode/web",
  prod: "https://receiver-metis.infeng.site/encode/web",
};
